export default __webpack_public_path__ + "static/media/copy.99b6b111.svg";